import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required.";
    if (!form.email.trim()) e.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email.";
    if (form.phone && !/^\+?[\d\s\-()]{7,15}$/.test(form.phone)) e.phone = "Enter a valid phone number.";
    if (!form.message.trim()) e.message = "Message is required.";
    return e;
  };

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setErrors((er) => ({ ...er, [e.target.name]: undefined }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitted(true);
  };

  return (
    <>
      <style>{css}</style>

      {/* PAGE HEADER */}
      <header className="products-header">
        <div className="products-header__bg" aria-hidden="true" />
        <div className="container">
          <span className="products-header__eyebrow">✦ Get In Touch</span>
          <h1 className="products-header__title">Contact Us</h1>
          <p className="products-header__sub">We'd love to hear from you — reach out anytime</p>
        </div>
      </header>

      <div className="container contact-layout">
        <div className="contact-grid">

          {/* FORM CARD */}
          <div className="contact-card">
            <h2 className="contact-card__title">Send a Message</h2>

            {submitted ? (
              <div className="contact-success">
                <span className="contact-success__icon">🌿</span>
                <h3>Thank you!</h3>
                <p>Your message has been received. We'll get back to you within 24 hours.</p>
                <button className="btn-primary" onClick={() => { setSubmitted(false); setForm({ name: "", email: "", phone: "", message: "" }); }}>
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="name">Full Name <span className="form-required">*</span></label>
                    <input
                      id="name" name="name" type="text"
                      className={`form-input${errors.name ? " form-input--error" : ""}`}
                      placeholder="Your full name"
                      value={form.name} onChange={handleChange}
                    />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="email">Email Address <span className="form-required">*</span></label>
                    <input
                      id="email" name="email" type="email"
                      className={`form-input${errors.email ? " form-input--error" : ""}`}
                      placeholder="you@example.com"
                      value={form.email} onChange={handleChange}
                    />
                    {errors.email && <span className="form-error">{errors.email}</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="phone">Phone Number</label>
                  <input
                    id="phone" name="phone" type="tel"
                    className={`form-input${errors.phone ? " form-input--error" : ""}`}
                    placeholder="+91 98765 43210"
                    value={form.phone} onChange={handleChange}
                  />
                  {errors.phone && <span className="form-error">{errors.phone}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="message">Message <span className="form-required">*</span></label>
                  <textarea
                    id="message" name="message" rows={5}
                    className={`form-input form-textarea${errors.message ? " form-input--error" : ""}`}
                    placeholder="How can we help you?"
                    value={form.message} onChange={handleChange}
                  />
                  {errors.message && <span className="form-error">{errors.message}</span>}
                </div>
                <button type="submit" className="btn-primary contact-submit">Send Message ✦</button>
              </form>
            )}
          </div>

          {/* INFO + MAP */}
          <div className="contact-side">
            <div className="contact-info-card">
              <h3 className="contact-info-card__title">Visit Us</h3>
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <span className="contact-info-icon">📍</span>
                  <div>
                    <strong>Address</strong>
                    <p>OOP - New SP School, Sunflower School, Main Road, Surendranagar 363002</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-icon">📞</span>
                  <div>
                    <strong>Phone</strong>
                    <p>+91 90235 10912</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-icon">✉️</span>
                  <div>
                    <strong>Email</strong>
                    <p>hello@sanjivani.in</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-icon">🕐</span>
                  <div>
                    <strong>Hours</strong>
                    <p>Mon – Sat: 9:00 AM – 7:00 PM<br />Sun: 10:00 AM – 4:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-map-wrap">
              <iframe
                title="Sanjivani Ayurveda Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.8821651788!2d72.5663!3d23.0395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDAyJzIyLjIiTiA3MsKwMzMnNTguNyJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
                width="100%" height="220"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');

:root {
  --c-primary:       #2d6a4f;
  --c-primary-light: #40916c;
  --c-primary-dark:  #1b4332;
  --c-accent:        #d4a017;
  --c-bg:            #f9f6f0;
  --c-surface:       #ffffff;
  --c-text:          #1c2b22;
  --c-muted:         #5a7262;
  --c-border:        #d4e6d5;
  --c-error:         #c0392b;
  --f-display:       'Cormorant Garamond', Georgia, serif;
  --f-body:          'Jost', sans-serif;
  --radius:          14px;
  --shadow:          0 4px 24px rgba(27,67,50,.09);
  --shadow-lg:       0 12px 40px rgba(27,67,50,.15);
  --ease:            cubic-bezier(.4,0,.2,1);
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: var(--f-body); background: var(--c-bg); color: var(--c-text); }

.container { max-width: 1160px; margin: 0 auto; padding: 0 24px; }

.products-header {
  position: relative; overflow: hidden;
  padding: 100px 0 50px;
  background: linear-gradient(135deg, var(--c-primary-dark) 0%, #1e4d35 60%, #163d2a 100%);
  text-align: center;
}
.products-header__bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse 60% 80% at 80% 50%, rgba(64,145,108,.22), transparent 60%),
    radial-gradient(ellipse 40% 60% at 10% 80%, rgba(212,160,23,.10), transparent 55%);
}
.products-header__eyebrow {
  display: inline-block; font-size: .72rem; font-weight: 600;
  letter-spacing: .2em; text-transform: uppercase;
  color: var(--c-accent); background: rgba(212,160,23,.14);
  padding: 5px 16px; border-radius: 100px; margin-bottom: 16px;
}
.products-header__title {
  font-family: var(--f-display); font-size: clamp(2.2rem, 5vw, 3.5rem);
  font-weight: 600; color: #fff; line-height: 1.15; margin-bottom: 12px;
}
.products-header__sub { font-size: .9rem; color: rgba(255,255,255,.58); font-weight: 300; letter-spacing: .06em; }

.contact-layout { padding-top: 48px; padding-bottom: 80px; }

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 32px;
  align-items: start;
}

/* FORM CARD */
.contact-card {
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
  padding: 36px;
  box-shadow: var(--shadow);
}
.contact-card__title {
  font-family: var(--f-display); font-size: 1.7rem; font-weight: 600;
  color: var(--c-primary-dark); margin-bottom: 28px;
}

.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
.form-group { display: flex; flex-direction: column; margin-bottom: 18px; }
.form-label { font-size: .78rem; font-weight: 600; letter-spacing: .07em; text-transform: uppercase; color: var(--c-muted); margin-bottom: 7px; }
.form-required { color: var(--c-error); }
.form-input {
  font-family: var(--f-body); font-size: .9rem;
  padding: 11px 16px; border-radius: 10px;
  border: 1.5px solid var(--c-border);
  background: var(--c-bg); color: var(--c-text);
  outline: none; transition: border-color .22s, box-shadow .22s;
}
.form-input:focus { border-color: var(--c-primary-light); box-shadow: 0 0 0 3px rgba(64,145,108,.15); }
.form-input::placeholder { color: var(--c-muted); }
.form-input--error { border-color: var(--c-error); }
.form-textarea { resize: vertical; min-height: 130px; }
.form-error { font-size: .74rem; color: var(--c-error); margin-top: 5px; }

.contact-submit { width: 100%; justify-content: center; margin-top: 6px; }

/* SUCCESS */
.contact-success { text-align: center; padding: 40px 20px; }
.contact-success__icon { font-size: 3.5rem; display: block; margin-bottom: 14px; }
.contact-success h3 { font-family: var(--f-display); font-size: 1.8rem; font-weight: 600; color: var(--c-primary-dark); margin-bottom: 10px; }
.contact-success p { font-size: .95rem; color: var(--c-muted); margin-bottom: 24px; }

/* SIDE */
.contact-side { display: flex; flex-direction: column; gap: 20px; }

.contact-info-card {
  background: var(--c-surface); border: 1px solid var(--c-border);
  border-radius: var(--radius); padding: 28px; box-shadow: var(--shadow);
}
.contact-info-card__title {
  font-family: var(--f-display); font-size: 1.4rem; font-weight: 600;
  color: var(--c-primary-dark); margin-bottom: 20px;
}
.contact-info-list { display: flex; flex-direction: column; gap: 18px; }
.contact-info-item { display: flex; gap: 14px; align-items: flex-start; }
.contact-info-icon { font-size: 1.2rem; margin-top: 2px; flex-shrink: 0; }
.contact-info-item strong { display: block; font-size: .78rem; font-weight: 600; letter-spacing: .07em; text-transform: uppercase; color: var(--c-primary); margin-bottom: 3px; }
.contact-info-item p { font-size: .88rem; color: var(--c-muted); line-height: 1.5; }

.contact-map-wrap {
  border-radius: var(--radius); overflow: hidden;
  border: 1px solid var(--c-border); box-shadow: var(--shadow);
}

.btn-primary {
  display: inline-flex; align-items: center; gap: 8px;
  font-family: var(--f-body); font-size: .82rem; font-weight: 600;
  letter-spacing: .07em; text-transform: uppercase;
  padding: 12px 28px; border-radius: 100px; border: none;
  background: var(--c-primary); color: #fff; cursor: pointer;
  transition: background .22s, transform .22s;
}
.btn-primary:hover { background: var(--c-primary-dark); transform: translateY(-1px); }

@media (max-width: 860px) {
  .contact-grid { grid-template-columns: 1fr; }
  .form-row { grid-template-columns: 1fr; }
}
@media (max-width: 480px) {
  .contact-card { padding: 22px; }
}
`;
